import { useStatusQueryFilter } from '@app/modules/logger/screens/status/hooks/useStatusQueryFilter';
import { SearchInput } from '@ui/components';

export function StatusesTextFilter() {
  const { queryParams, setQueryParams } = useStatusQueryFilter();

  return (
    <SearchInput
      className="search-stations"
      placeholder=""
      value={queryParams.text}
      onSearch={(text) => setQueryParams({ text })}
    />
  );
}
